import { useQuery } from '@tanstack/react-query';
import type { ProjectCalendarResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

/**
 * Projects plotted on the shared calendar for an inclusive [from, to] business-day
 * range. Driven by the calendar's visible range (datesSet); disabled until set.
 */
export function useProjectCalendar(from: string | null, to: string | null) {
  return useQuery<ProjectCalendarResponse>({
    queryKey: ['project-calendar', from, to],
    enabled: !!from && !!to,
    queryFn: () =>
      apiCall<ProjectCalendarResponse>(
        `/projects/calendar?from=${from}&to=${to}`,
      ),
  });
}
